import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAwlhufSiR_vOyuk9HZ2UmoZAInlSRBJpg',
  authDomain: 'c-audit-dashboard.firebaseapp.com',
  projectId: 'c-audit-dashboard',
  storageBucket: 'c-audit-dashboard.firebasestorage.app',
  messagingSenderId: '1012995198126',
  appId: '1:1012995198126:web:c3795e63dc56b5be5a313f',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
